var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSubtract = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    className: "svg-subtract",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.6422C24 19.2697 18.6274 24.6422 12 24.6422C5.37258 24.6422 0 19.2697 0 12.6422C0 6.01483 5.37258 0.642242 12 0.642242C18.6274 0.642242 24 6.01483 24 12.6422ZM12 20.3089C11.4477 20.3089 11 19.8612 11 19.3089V13.6422H5.33398C4.7817 13.6422 4.33398 13.1945 4.33398 12.6422C4.33398 12.09 4.7817 11.6422 5.33398 11.6422H11V5.97559C11 5.4233 11.4477 4.97559 12 4.97559C12.5523 4.97559 13 5.4233 13 5.97559V11.6422H18.6673C19.2196 11.6422 19.6673 12.09 19.6673 12.6422C19.6673 13.1945 19.2196 13.6422 18.6673 13.6422H13V19.3089C13 19.8612 12.5523 20.3089 12 20.3089Z",
    fill: "#8F27C7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSubtract);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Subtract.690c262794333d8b626e13f413e8adf5.svg";